import { Link, Menu, MenuItem, Tooltip } from '@material-ui/core';
import React, { useMemo, useState } from 'react';
import { useTranslate } from 'react-admin';
import DownloadIcon from '@material-ui/icons/GetApp';
import queryString from 'query-string';
import omit from 'lodash/omit';
import { EXPORT_FILE_TYPE } from '../../../../constant/invoice';
import { useAccountInvoiceBalanceListContext } from './AccountInvoiceBalanceProvider';
import { Button } from '../../../../base/components/ra/buttons';
import { getQueryUrl } from '../../../../services/provider/dataProvider';
import resourceSlug from '../../../../constant/resource-slug';

export default function ExportButton({ disabled }) {
  const t = useTranslate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const { appliedFilters } = useAccountInvoiceBalanceListContext();

  const query = useMemo(() => {
    const { query: queryStr } = getQueryUrl(resourceSlug.ACCOUNT_STATEMENT, {
      filter: appliedFilters,
    });
    const parsed = queryString.parse(queryStr);
    const sanitizedQuery = omit(parsed, ['limit', 'page', 'offset']);
    return queryString.stringify(sanitizedQuery);
  }, [appliedFilters]);

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Tooltip title={t('ra.action.export')}>
        <Button
          aria-controls={open ? 'dropdown-menu' : undefined}
          aria-haspopup="true"
          onClick={handleClick}
          size="small"
          minWidth={30}
          disabled={disabled}
          label="ra.action.export"
        >
          <DownloadIcon fontSize="small" />
        </Button>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        getContentAnchorEl={null}
      >
        {Object.values(EXPORT_FILE_TYPE).map((type) => (
          <MenuItem
            key={type}
            component={Link}
            target="_blank"
            href={`api/account-invoice-balance/export?${query}&exportFileType=${type}`}
            onClick={(e) => {
              e.stopPropagation();
              handleClose();
            }}
          >
            {t(`common.exportFileType.${type}`)}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
